import { EqCondition, useFilterContext } from 'framework/list';
import { FilterCondition } from 'framework/types';
import React, { useEffect, useState } from 'react';
import { useDateService, DEFAULT_TIMEZONE, useDateTimeService } from 'framework/utils';
import momentTimezone from 'moment-timezone';
import { DateTimeInput } from 'framework/form';

const FILTER_ERROR =
  'Please, choose the correct date and time at which you want to generate the snapshot. This date and time should be in the past.';

type AuditDateFilterProps = {
  source: string;
};

const AuditDateFilter = ({ source }: AuditDateFilterProps) => {
  const [timezone, setTimezone] = useState<string>(DEFAULT_TIMEZONE);
  const { filters, getFilterErrors, setFilterErrors } = useFilterContext();
  const { getToday } = useDateService();
  const { getTimezone } = useDateTimeService();

  useEffect(() => {
    (async () => {
      let userTimezone = null;
      if (getTimezone) {
        userTimezone = await getTimezone();
      }
      if (userTimezone) {
        setTimezone(userTimezone);
      }
    })();
    // Suppressed warnings because we only need to call useEffect callback ones after the first mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const maxDate = getToday();

  const validateAndShowErrorMessages = () => {
    const inputValue = filters && filters[source] && filters[source][FilterCondition.EQ];
    const date = momentTimezone.tz(inputValue, timezone);
    const isValid = inputValue && date.isValid() && date.isSameOrBefore(maxDate);
    const showErrors = !isValid;
    if (showErrors) {
      setFilterErrors(source, FilterCondition.EQ, [FILTER_ERROR]);
    } else {
      setFilterErrors(source, FilterCondition.EQ, []);
    }
    return showErrors;
  };

  const getErrors = () => {
    return getFilterErrors(source, FilterCondition.EQ);
  };

  return (
    <EqCondition source={source}>
      <DateTimeInput
        isRequired
        label="Date and time of the snapshot"
        validationCallback={validateAndShowErrorMessages}
        errorMessages={getErrors()}
        maxDate={maxDate}
        source={source}
      />
    </EqCondition>
  );
};

export default AuditDateFilter;
